import TechDocumentList from "../../views/modules/Development/documents/DocumentsList";
import Techdevelopment from "../../views/modules/Development/development";
import InternalR from "@/views/apps/internal_requests/requests/index.vue";
import internalRTech from "@/views/apps/internal_requests/KPI/internalRTech.vue";
// import trainingte from "@/views/apps/cmi/training/mview/index";
import channelMview from "@/views/apps/cmi/training/mview/channelMview.vue";
import RequestList from "../../views/modules/technical_support/requests/RequestList";
import AuthorizerSwitcher from "@/views/modules/authorizer/switcher/switcher.vue";
import HistoryJobs from "../../views/modules/HistoryJobs/HistoryJobs.vue";
//import HisotryjobsDirections from "../../views/modules/HistoryJobs/HistoryJobsDirections/HistoryJobsDirections.vue";
import layouts from "../../layout";
import SolicitudesAsignacion from "@/views/modules/technical_support/reports/ReportRequestByTechnical.vue";

export default {
  path: "/technology",
  name: "technology",
  component: Techdevelopment,
  meta: {
    auth: true
  },
  redirect: {
    name: "technology-request"
  },
  children: [
    {
      path: "requests",
      name: "technology-request",
      component: RequestList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Requests",
        tags: ["technology", "requests"],
        index: true
      }
    },
    {
      path: "internalrtech",
      name: "internalRequestsIndexDC",
      component: internalRTech,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Mis Solicitudes",
        tags: ["flow", "activity", "activity_flow"],
        index: true
      },

      children: [
        {
          path: "internalrequets",
          name: "internal-requests-documentsdctest",
          component: InternalR,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Solicitudes",
            tags: ["internal-requests", "Solicitudes"],
            index: true
          }
        },
        {
          path: "tech-per-support-internal",
          name: "tech-requests-kpi-per-support",
          component: () =>
            import("@/views/apps/internal_requests/KPI/SLA/KpiSoporteTecnico"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "SLA",
            tags: ["support", "sla"],
            index: true
          }
        },
        {
          path: "tech-per-satisfactions-internal",
          name: "tech-requests-kpi-per-satisfactions",
          component: () =>
            import(
              "@/views/apps/internal_requests/KPI/Satisfaccion/KpiSatisfaccion"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Satisfaction",
            tags: ["support", "sla"],
            index: true
          }
        },
        {
          path: "Report-per-Responsable-internaltech",
          name: "tech-requests-report-per-responsable",
          component: () =>
            import(
              "@/views/apps/internal_requests/KPI/InternalRequestbyResponsable.vue"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Internals Requests Report",
            tags: ["support", "sla"],
            index: true
          }
        },
        {
          path: "documentsdc",
          name: "internal-requests-documentsdc",
          component: () =>
            import("@/views/apps/internal_requests/documents/DocumentList"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Document",
            tags: ["internal-requests", "documents"],
            index: true
          }
        },

        {
          path: "training-cmitech",
          name: "training-cmitech",
          component: {
            render: (h) => h("router-view")
          },
          meta: {
            auth: true,
            index: true
          },
          children: [
            {
              path: "cmi-links-channels-magytech",
              name: "cmi-training-links-channels-magytech",
              component: channelMview,
              meta: {
                auth: true,
                searchable: true,
                layout: layouts.navLeft,
                title: "Document",
                tags: ["internal-requests", "documents"],
                index: true
              }
            }
          ]
        }
      ]
    },
    {
      path: "external-processes",
      name: "tech-external-processes",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Procesos externos",
        tags: ["Procesos-Externos"],
        index: true
      },
      children: [
        {
          path: "authorizer-switcher",
          name: "technology-authorizer-switcher",
          component: AuthorizerSwitcher,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "switcher",
            tags: ["technology", "authorizer", "switcher"],
            index: true
          }
        },
        {
          path: "technology-HistoryJobs",
          name: "technology-HistoryJobs-documentTB",
          component: HistoryJobs,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Documents",
            tags: ["technology", "legaltb", "documents"],
            index: true
          }
        }
      ]
    },
    {
      path: "tech-report-report",
      name: "tech-report-report",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Procesos externos",
        tags: ["Procesos-Externos"],
        index: true
      },
      children: [
        {
          path: "technology-SolicitudesAsignacion",
          name: "technology-Reporte-SolicitudesAsignacion",
          component: SolicitudesAsignacion,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Documents",
            tags: ["technology", "legaltb", "documents"],
            index: true
          }
        }
      ]
    },
    {
      path: "internal-processes",
      name: "tech-internal-processes",
      component: () =>
        import("@/components/internal-processes/InternalProcesses.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Procesos internos",
        tags: ["Procesos-Interno"],
        index: true
      }
    },
    {
      path: "rdl-equipostech",
      name: "rdl-equipostechno",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Herramientas Soporte",
        tags: ["flow", "activity", "activity_flow"],
        index: true
      },

      children: [
        {
          path: "rdl-equiposstech",
          name: "rdl-equiposstech",
          component: () => import("@/views/apps/ncfmovil/EmpresasList.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Equipos",
            tags: ["Tech ncfmovil", "Technology"],
            index: true
          }
        },
        {
          path: "balance-reporttech",
          name: "tech-balance-report",
          component: () =>
            import("@/views/apps/ncfmovil/Reports/SUPPLIER_BALANCE_REPORT.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Balance Report",
            tags: ["balance tech", "suppliers"],
            index: true
          }
        },
        {
          path: "ticket-reporttech",
          name: "tech-ticket-report",
          component: () =>
            import("@/views/apps/ncfmovil/Reports/TicketSearch.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Ticket Report",
            tags: ["balance tech", "suppliers"],
            index: true
          }
        },
        {
          path: "get-ticket-reporttech",
          name: "tech-ticket-generacion-report",
          component: () => import("@/views/apps/ncfmovil/TicketsReport.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Ticket Report",
            tags: ["balance tech", "suppliers"],
            index: true
          }
        },
        {
          path: "transaction-reporttech",
          name: "tech-transaction-report",
          component: () =>
            import("@/views/apps/ncfmovil/TransactionReport.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Transaction Report",
            tags: ["balance tech", "suppliers"],
            index: true
          }
        },
        {
          path: "get-card-balance-reporttech",
          name: "tech-card-balance-report",
          component: () =>
            import("@/views/apps/ncfmovil/CardBalanceReport.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Transaction Report",
            tags: ["balance tech", "suppliers"],
            index: true
          }
        }
      ]
    },
    {
      path: "technologydc",
      name: "technologydc",
      component: TechDocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "technology Documents",
        tags: ["technology", "documents"],
        index: true
      }
    },
    {
      path: "reportsurvey",
      name: "employeesTechnology-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Empleados",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    },
    {
      path: "controlversion",
      name: "employeesTechnology-controlversion",
      component: () => import("@/components/technology/ControlVersion.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Control de versiones",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    },
    {
      path: "certifications-ecf",
      name: "employeesTechnology-certifications",
      component: () =>
        import("@/components/technology/certifications/CertificationsCard.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Comprobantes Electrónicos",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    }
    /*
    {
      path: "techinfrastructure",
      name: "infrastructureT",
      component: () =>
        import("@/views/modules/infrastructure/documents/DocumentsList1"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Infrastructure Documents",
        tags: ["technology", "documents"],
        index: true
      }
    },
    */
  ]
};
